;(function () {
  'use strict'

  angular.module('contrast.charts', [])
})()
